import React from 'react';
import { AppContext } from '../App/AppProvider';

export default function ({firstVisit}) {
  return (
    <AppContext.Consumer>
      {({firstVisit}) => 
        firstVisit ? <div>
          Welcome to CoinbaseDash, please SELECT your Favorite Coins to begin.{' '}
        </div> : null     
      }
    </AppContext.Consumer>
  )
}